import React from "react";
import ProSourceForm from "../../components/ProSourceForm";
import { Modal, Form, Button, Card, Row, Col } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import {
  capitalizeFirstLetter,
  capitalizeText,
  fetchData,
  getToolTitleFromToolName,
  Humanize,
  showConfirmationSwal,
} from "../../helpers";
import ConfirmPasswordModal from "../../partials/ConfirmPasswordModal";
import { FormItem } from "../../components/Base";

class AdminToolsUserToolModal extends ProSourceForm {
  constructor(props) {
    super(props);
    this.state = {
      values: {
        old_user_role: "",
        new_user_role: "",
        delete_user_note: "",
        restore_user_note: "",
      },
      url: "",
      showPasswordConfirmModal: false,
      errors: [],
      touched: {},
      redirectTo: "",
      isSubmitting: false,
      isChecking: false,
    };
  }

  handleOnClickItem = (itemUrl, newHistory) => {
    let { url } = this.state;
    url = itemUrl;
    this.setState({ url });
    newHistory.push(itemUrl);
  };

  handleClearForms = () => {
    const { values } = this.state;
    values.old_user_role = "";
    values.new_user_role = "";
    values.delete_user_note = "";
    values.restore_user_note = "";
    this.setState({ values });
  };

  handleCloseModal = () => {
    this.props.onHide();
    this.handleClearForms();
  };

  handleSwitchToolConfirm = async (values, setSubmitting) => {
    const { toolName } = this.props;
    switch (toolName) {
      case "change_user_role":
        this.handleOnConfirmChangeUserRole(values, setSubmitting);
        break;
      case "delete_user":
        this.handleOnConfirmDeleteUser(values, setSubmitting);
        break;
      case "restore_user":
        this.handleOnConfirmRestoreUser(values, setSubmitting);
        break;
      default:
        console.log("no tool selected");
    }
  };

  handleOnConfirmChangeUserRole = async (values, setSubmitting) => {
    const { new_user_role } = this.state.values;
    const { data = [] } = this.props;
    values.old_user_role = data.iam_role;
    values.new_user_role = new_user_role;
    values.email = data.email;
    const response = await fetchData(
      "put",
      `/admintools/users/${data._id}/change_user_role`,
      { values },
    );
    const successMessage = "User Role Updated Successfully";
    showConfirmationSwal(response, successMessage);
    values.confirm_password = "";
    this.setState({ showPasswordConfirmModal: false });
    if (response.data.result !== "error") {
      this.handleCloseModal();
      this.props.handleRefreshUser();
      this.handleClearForms();
    }
    setSubmitting(false);
  };

  handleSelectUserRole = (event) => {
    const { values } = this.state;
    values.new_user_role = event.target.value;
    this.setState({ values });
  };

  handleOnConfirmDeleteUser = async (values, setSubmitting) => {
    const { delete_user_note } = this.state.values;
    const { data = [] } = this.props;
    values.delete_user_note = delete_user_note;
    values.email = data.email;
    const response = await fetchData(
      "post",
      `/admintools/users/${data._id}/delete_user`,
      { values },
    );
    const successMessage = "User Deleted Successfully";
    showConfirmationSwal(response, successMessage);
    values.confirm_password = "";
    this.setState({ showPasswordConfirmModal: false });
    if (response.data.result !== "error") {
      this.handleCloseModal();
      this.props.handleRefreshUser();
      this.handleClearForms();
    }
    setSubmitting(false);
  };

  handleOnConfirmRestoreUser = async (values, setSubmitting) => {
    const { restore_user_note } = this.state.values;
    const { data = [] } = this.props;
    values.restore_user_note = restore_user_note;
    values.email = data.email;
    const response = await fetchData(
      "put",
      `/admintools/users/${data._id}/restore_user`,
      { values },
    );
    const successMessage = "User Restored Successfully";
    showConfirmationSwal(response, successMessage);
    values.confirm_password = "";
    this.setState({ showPasswordConfirmModal: false });
    if (response.data.result !== "error") {
      this.handleCloseModal();
      this.props.handleRefreshUser();
      this.handleClearForms();
    }
    setSubmitting(false);
  };

  isProceedButtonDisabled = () => {
    const { toolName } = this.props;
    const { values } = this.state;

    if (toolName === "change_user_role") {
      if (!values.new_user_role) return true;
    }
    if (toolName === "delete_user") {
      if (!values.delete_user_note) return true;
    }
    if (toolName === "restore_user") {
      if (!values.restore_user_note) return true;
    }
    return false;
  };

  setConfirmMessageFromToolName = (toolName) => {
    const { values } = this.state;
    switch (toolName) {
      case "change_user_role":
        return (
          <>
            <span>{`You are changing the User Role to `}</span>
            <span className="text-danger font-weight-bolder">
              {capitalizeText(Humanize(values.new_user_role))}.
            </span>
          </>
        );
      case "delete_user":
        return `You are deleting this user.`;
      case "restore_user":
        return `You are restoring this user.`;
      default:
        return `${toolName}`;
    }
  };

  render() {
    const { show = false, toolName, data = [] } = this.props;
    const { showPasswordConfirmModal } = this.state;

    const actions = {
        handleFeedbackError: this.handleFeedbackError,
        isTouched: this.isTouched,
      },
      inputActions = {
        onChange: this.handleOnChange,
        onBlur: this.handleOnBlur,
      };

    onsubmit = (e) => {
      e.preventDefault();
      this.setState({ showPasswordConfirmModal: true });
    };

    return (
      <>
        <ConfirmPasswordModal
          show={showPasswordConfirmModal}
          onHide={() => {
            this.setState({ showPasswordConfirmModal: false });
          }}
          body={
            <>
              <p className="text-dark">
                {this.setConfirmMessageFromToolName(toolName)}
              </p>
            </>
          }
          onSubmit={this.handleSwitchToolConfirm}
        />

        <Modal
          show={show}
          onHide={this.handleCloseModal}
          className="modal-content-xl"
          centered
        >
          <Modal.Header>
            <Modal.Title>{getToolTitleFromToolName(toolName)}</Modal.Title>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.handleCloseModal}
            >
              <i aria-hidden="true" className="ki ki-close"></i>
            </button>
          </Modal.Header>
          <Form onSubmit={this.onSubmit}>
            <Modal.Body>
              <Row>
                <Col>
                  {toolName === "restore_user" ? (
                    <>
                      <DeletedUserDataForm
                        data={data}
                        values={this.state.values}
                        inputActions={inputActions}
                        actions={actions}
                      />
                    </>
                  ) : (
                    <>
                      <UserDataForm
                        data={data}
                        values={this.state.values}
                        inputActions={inputActions}
                        actions={actions}
                      />
                    </>
                  )}
                </Col>
                <Col>
                  {toolName === "change_user_role" ? (
                    <>
                      <ChangeUserRoleForm
                        data={data}
                        values={this.state.values}
                        inputActions={inputActions}
                        actions={actions}
                        handleSelectUserRole={this.handleSelectUserRole}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                  {toolName === "delete_user" ? (
                    <>
                      <DeleteUserForm
                        data={data}
                        values={this.state.values}
                        inputActions={inputActions}
                        actions={actions}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                  {toolName === "restore_user" ? (
                    <>
                      <RestoreUserForm
                        data={data}
                        values={this.state.values}
                        inputActions={inputActions}
                        actions={actions}
                      />
                    </>
                  ) : (
                    <></>
                  )}

                  <Card className="border card-custom mt-4">
                    <Card.Title className="pb-0 mb-0"></Card.Title>
                    <Card.Body>
                      <Button
                        type="submit"
                        className="btn-block text-uppercase font-weight-bold"
                        disabled={this.isProceedButtonDisabled()}
                      >
                        Proceed
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Modal.Body>
          </Form>
        </Modal>
      </>
    );
  }
}

class UserDataForm extends AdminToolsUserToolModal {
  render() {
    const { data, values, inputActions, actions } = this.props;
    return (
      <>
        <Card className="border card-custom mt-4">
          <Card.Title className="pb-0 mb-0"></Card.Title>
          <Card.Body className="d-flex flex-column align-items-start">
            <div>
              <span className="text-muted">User Email: </span>
              <span className="font-weight-bolder">{data.email}</span>
            </div>
            <div>
              <span className="text-muted">Client: </span>
              <span className="font-weight-bolder">
                {data.client_id && data.client_id.name
                  ? data.client_id.name
                  : `-`}
              </span>
            </div>
            <div>
              <span className="text-muted">User Role: </span>
              <span className="font-weight-bolder">
                {capitalizeText(Humanize(data.iam_role))}
              </span>
            </div>
            <div>
              <span className="text-muted">Name: </span>
              <span className="font-weight-bolder">{`${data.first_name} `}</span>
              <span className="font-weight-bolder">{data.last_name}</span>
            </div>
          </Card.Body>
        </Card>
      </>
    );
  }
}

class DeletedUserDataForm extends AdminToolsUserToolModal {
  render() {
    const { data } = this.props;
    return (
      <>
        <Card className="border card-custom mt-4">
          <Card.Title className="pb-0 mb-0"></Card.Title>
          <Card.Body className="d-flex flex-column align-items-start">
            <div>
              <span className="text-muted">User Email: </span>
              <span className="font-weight-bolder">{data.origin_key}</span>
            </div>
            <div>
              <span className="text-muted">User ID: </span>
              <span className="font-weight-bolder">{data.origin_id}</span>
            </div>
            <div>
              <span className="text-muted">Date Deleted: </span>
              <span className="font-weight-bolder">{data.date_created}</span>
            </div>
          </Card.Body>
        </Card>
      </>
    );
  }
}

class ChangeUserRoleForm extends AdminToolsUserToolModal {
  // userRoles = [
  //   "super_admin", // formerly 'admin'
  //   "system_admin",
  //   "group_admin", // formerly "client_admin"
  //   "brand_admin",
  //   "store_admin", // formerly "store"
  //   "console_user",
  //   "console_user_dispatch",
  //   "console_user_counter",
  //   "accounting",
  //   "customer",
  //   "admin", // to be deprecated
  //   "client_admin", // to be deprecated
  //   "store", // to be deprecated
  // ];

  constructor(props) {
    super(props);
    this.state = {
      userRoles: [],
    };
  }

  async componentDidMount() {
    const {
      data: { userRoles },
    } = await fetchData("get", "/admintools/userroles");
    this.setState({ userRoles });
  }

  render() {
    const { data, values, inputActions, handleSelectUserRole, actions } =
      this.props;
    const { userRoles = [] } = this.state;
    return (
      <>
        <Card className="border card-custom mt-4">
          <Card.Title className="pb-0 mb-0"></Card.Title>
          <Card.Body>
            <FormItem
              label={"Current User Role"}
              name={"old_user_role"}
              inputProps={{
                name: "old_user_role",
                // placeholder: "Old Store Name",
                // value: values["old_store_name"],
                value: capitalizeText(Humanize(data.iam_role)),
                disabled: true,
              }}
              inputActions={inputActions}
              actions={actions}
              type={"text"}
              normal
            />
            <div className="font-weight-bolder">New User Role</div>
            <select
              className="form-control"
              name="user_roles"
              placeholder="User Roles"
              // onChange={(e) => {
              //   setFieldValue("status", e.target.value);
              //   handleSubmit();
              // }}
              onChange={(event) => handleSelectUserRole(event)}
              onBlur={actions.handleBlur}
              // value={values.new_user_role}
            >
              <option value="">Select User Role</option>
              {/* {userRoles.map((element) => {
                if (!["super_admin", "system_admin"].includes(element)) {
                  return <option value={`${element}`}>{element}</option>;
                } */}
              {userRoles.map((element) => {
                return (
                  <option key={element} value={`${element}`}>
                    {capitalizeText(Humanize(element))}
                  </option>
                );
              })}
            </select>
          </Card.Body>
        </Card>
      </>
    );
  }
}

class DeleteUserForm extends AdminToolsUserToolModal {
  render() {
    const { data, values, inputActions, actions } = this.props;
    return (
      <>
        <Card className="border card-custom mt-4">
          <Card.Title className="pb-0 mb-0"></Card.Title>
          <Card.Body>
            <FormItem
              label={"Note"}
              name={"delete_user_note"}
              inputProps={{
                name: "delete_user_note",
                placeholder: "Note",
                value: values["delete_user_note"],
              }}
              inputActions={inputActions}
              actions={actions}
              type={"text"}
              showRequired={true}
              normal
            />
          </Card.Body>
        </Card>
      </>
    );
  }
}

class RestoreUserForm extends AdminToolsUserToolModal {
  render() {
    const { data, values, inputActions, actions } = this.props;
    return (
      <>
        <Card className="border card-custom mt-4">
          <Card.Title className="pb-0 mb-0"></Card.Title>
          <Card.Body>
            <FormItem
              label={"Note"}
              name={"restore_user_note"}
              inputProps={{
                name: "restore_user_note",
                placeholder: "Note",
                value: values["restore_user_note"],
              }}
              inputActions={inputActions}
              actions={actions}
              type={"text"}
              showRequired={true}
              normal
            />
          </Card.Body>
        </Card>
      </>
    );
  }
}

export default withRouter(AdminToolsUserToolModal);
